let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3yAl4"), load("aiCDP")]).then(() => parcelRequire('f5jWz'));